import { IStoreState } from '../types';
import { IColorPreset } from '../constants/colorPresets';

export const getAreColorPresetsFetched = (state: IStoreState) => state.colorPresets.isFetched;

/** Every active palette. The backend owns them; there is no local list. */
export const getColorPresets = (state: IStoreState): IColorPreset[] => state.colorPresets.items;
